export default (input, rules) => {
    const failingRule = rules.find(rule => !rule.validate(input));
    if (failingRule) {
        return {
            isValid: false,
            ...failingRule.getErrorKeys()
        };
    }
    return {
        isValid: true
    };
};
